var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.639872 19.9116C0.0268767 20.6627 0.138895 21.7686 0.890073 22.3816C1.64125 22.9946 2.74713 22.8826 3.36013 22.1314L0.639872 19.9116ZM19.2856 1.80278C19.1879 0.838162 18.3267 0.135395 17.3621 0.233105L1.64273 1.82537C0.678111 1.92308 -0.024656 2.78427 0.0730528 3.74888C0.170763 4.7135 1.03195 5.41627 1.99656 5.31856L15.9693 3.90321L17.3847 17.8759C17.4824 18.8406 18.3435 19.5433 19.3082 19.4456C20.2728 19.3479 20.9755 18.4867 20.8778 17.5221L19.2856 1.80278ZM3.36013 22.1314L18.8991 3.08962L16.1788 0.86977L0.639872 19.9116L3.36013 22.1314Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.5c774a95383d30f936443f5d918dfdf6.svg";
export { ForwardRef as ReactComponent };